import {StaffAccessLevels} from "@/enums/StaffAccessLevels";

export default {
  computed: {
    user() {
      return this.$store.state.authModule.user;
    },
    isOrgAdmin() {
      return this.user.accessLevel === StaffAccessLevels.OrgAdmin;
    },
    isHomeAdmin() {
      return this.user.accessLevel === StaffAccessLevels.HomeAdmin;
    },
    isAdmins() {
      return this.isOrgAdmin || this.isHomeAdmin;
    }
  }
};